import { parse, theme } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  bg: "shade900"
}, "c1qph9wf");
export const buttonContainer = parse({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  justifyContent: {
    medium: "center"
  }
}, "b8rgeo7");
export const link = parse({
  width: {
    _: "100%",
    medium: "auto"
  },
  display: "block",
  fontFamily: "artegra",
  fontWeight: "medium",
  color: "white",
  textAlign: "center",
  px: {
    medium: "48"
  },
  mx: {
    medium: "8"
  },
  mb: {
    _: "16",
    medium: "0"
  }
}, "l1xmzjjv");

require("./Contact.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Contact.styles.ts");